import React from 'react'
import PropTypes from 'prop-types'
import { Button, Tooltip } from 'reactstrap'
import { MdInsertLink } from 'react-icons/lib/md'
import styles from './LinkSlatePlugin.scss'
import { TRIGGER_KEY, onApply } from './LinkSlatePluginContainer'
import { hasLinks as hasLink } from './LinkUtils'

class LinkButton extends React.Component {
  constructor (props) {
    super(props)

    this.uid = Date.now()

    this.state = {
      tooltipOpen: false
    }
  }

  onClick = e => {
    return this.props.onChange(onApply(this.props.state))
  }

  toggle = () => {
    this.setState({
      tooltipOpen: !this.state.tooltipOpen
    })
  }

  render () {
    const { state: editorState, style, noTooltip } = this.props
    const isActive = hasLink(editorState)

    const customStyle = {}

    return (
      <Button
        id={'LinkButton' + this.uid}
        style={{...style, ...customStyle}}
        onClick={this.onClick}
        color={isActive ? 'primary' : 'secondary'}
        className={styles.LinkButton}
      > <MdInsertLink />
        {
          !noTooltip &&
          <Tooltip placement='top' isOpen={this.state.tooltipOpen} target={'LinkButton' + this.uid} toggle={this.toggle}>
            {
              editorState.isCollapsed
              ? 'Select text to insert link ' + `(CTL+${TRIGGER_KEY.toUpperCase()})`
              : 'Link ' + `(CTL+${TRIGGER_KEY.toUpperCase()})`
            }

          </Tooltip>
        }
      </Button>
    )
  }
}

LinkButton.propTypes = {
  state: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  noTooltip: PropTypes.bool,
  style: PropTypes.object
}

export default LinkButton



// WEBPACK FOOTER //
// ./src/components/LinkSlatePlugin/LinkButton.js